<div class="app-page-frame">
  @if (isAuthenticated()) {
    <app-home-navbar />
  } @else {
    <header class="app-page-chrome mb-8 justify-end">
      <a [routerLink]="['/']" class="brand-chip no-underline">
        <app-logo class="brand-chip-mark" [clickable]="false"></app-logo>
        <span class="brand-chip-label whitespace-nowrap">Kekeno Surveys</span>
      </a>
    </header>
  }

  <main class="app-page-content">
    <app-page-shell
      title="Terms of Service"
      description="The rules and responsibilities for using Kekeno Surveys to create questionnaires, invite respondents, collect responses, and view reports."
      icon="gavel"
      shellClass="help-page-shell"
    >
      <section class="page-section">
        <div class="space-y-4">
          @for (contentItem of content; track contentItem.title) {
            <section
              class="rounded-[10px] border border-textbox-border bg-surface-background p-5 lg:p-6"
            >
              <h2
                class="mb-2 font-spaceGrotesk text-[20px] text-inverted-neutral lg:text-[22px]"
              >
                {{ contentItem.title }}
              </h2>

              @if (contentItem.title === 'Data and Privacy') {
                <div class="space-y-3">
                  <p class="inter-400 text-[15px] leading-7 text-support-text">
                    Your use of the service is also subject to our
                    <a
                      [routerLink]="['/privacy-policy']"
                      class="text-kek-purple underline decoration-kek-purple/70 underline-offset-2 transition-opacity hover:opacity-80"
                    >
                      Privacy Policy
                    </a>.
                    You are responsible for ensuring that any data you upload,
                    import, collect, view, export, or share through Kekeno
                    Surveys is handled lawfully and with required permissions.
                  </p>
                </div>
              } @else if (contentItem.title === 'Contact') {
                <p class="inter-400 text-[15px] leading-7">
                  For terms questions, contact us at
                  <a
                    href="mailto:privacy@kekeno.co.nz"
                    class="text-kek-purple underline decoration-kek-purple/70 underline-offset-2 transition-opacity hover:opacity-80"
                  >
                    privacy@kekeno.co.nz
                  </a>.
                </p>
              } @else {
                <div class="space-y-3">
                  @for (paragraph of contentItem.paragraphs; track paragraph) {
                    <p class="inter-400 text-[15px] leading-7 text-support-text">
                      {{ paragraph }}
                    </p>
                  }

                  @if (contentItem.bullets?.length) {
                    <ul
                      class="inter-400 list-disc space-y-2 pl-5 text-[15px] leading-7 text-support-text"
                    >
                      @for (bullet of contentItem.bullets; track bullet) {
                        <li>{{ bullet }}</li>
                      }
                    </ul>
                  }
                </div>
              }
            </section>
          }
        </div>
      </section>
    </app-page-shell>
  </main>
</div>
